/**
 * Feature keys (ARCHITECTURE.md §17, DATABASE.md §7.1 `plan_features` / `tenant_features`).
 *
 * A feature key gates *behaviour* - whether a capability is offered to a tenant - and
 * is never an authorization decision: a disabled feature answers `FEATURE_DISABLED`,
 * a missing permission answers `FORBIDDEN`, and the two are checked separately
 * (rules §44.4). `packages/contracts/src/permissions.ts` owns the other half.
 *
 * This list is the single source of truth. `apps/api/prisma/seed.ts` imports it, so a
 * key cannot be seeded into `plan_features` or `tenant_features` without existing
 * here, and the database rows stay a closed set that the admin UI can enumerate.
 */
export const FEATURE_KEYS = [
    /** AI copay estimate on the insurance step (ADR-012). */
    'ai_estimate',
    /** Waitlist capture and offer flow. */
    'waitlist',
    /** Tenant-owned hostnames beyond `<slug>.<platform-domain>`. */
    'custom_domains',
    /** SMS notifications (phase 2). */
    'sms',
    /** Anonymous funnel analytics ping. */
    'analytics_ping',
    /** Improvement variant of the booking step sequence. */
    'booking_v2_steps',
    /** Integration categories, gated per plan (ARCHITECTURE.md §7.1). */
    'integration.ehr',
    'integration.eligibility',
    'integration.payment',
    'integration.email',
    /** Marketing CRM sync (ADR-028). Gates the `crm` category. */
    'integration.crm',
    'integration.analytics',
];
const FEATURE_KEY_SET = new Set(FEATURE_KEYS);
/** Narrows a value read from the database or an API payload to a known key. */
export function isFeatureKey(value) {
    return FEATURE_KEY_SET.has(value);
}
//# sourceMappingURL=features.js.map